<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.pr_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.pr_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.pr_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.pr_code" prop="ma">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ma"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col> 
             <b-col md="2">
              <el-form-item label=" " prop="co_hieu_luc">
                <el-checkbox
                  v-model="mData.dataForm.co_hieu_luc"
                  :disabled="mData.viewMode == 'detail'"
                >{{aLang.pr_effect}}</el-checkbox>
              </el-form-item>
            </b-col>           
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.pr_name + aLang.pr_vietnam" prop="ten.vi">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.vi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col> 
            <b-col md="6">
              <el-form-item :label="aLang.pr_name + aLang.pr_english" prop="ten.en">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.en"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>       
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.pr_content + aLang.pr_vietnam" prop="noi_dung.vi">
                <editor-component
                  :prop-data-editor="mData.dataForm.noi_dung"
                  :prop-data-editor-key="'vi'"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                ></editor-component>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.pr_content + aLang.pr_english" prop="noi_dung.en">
                <editor-component
                  :prop-data-editor="mData.dataForm.noi_dung"
                  :prop-data-editor-key="'en'"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                ></editor-component>
              </el-form-item>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.pr_start_time" prop="bat_dau">
                <el-date-picker
                  type="datetime"
                  v-model="mData.dataForm.bat_dau"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                >clearable</el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item :label="aLang.pr_end_time" prop="ket_thuc">
                <el-date-picker
                  type="datetime"
                  v-model="mData.dataForm.ket_thuc"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                >clearable</el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>      

          <b-row>
            <b-col md="12">
              <el-button
                type="info"
                plain
                @click="fn_openModalDoiTuong('create')"
                v-if="mData.viewMode != 'detail'"
              >{{aLang.pr_add_subject_to_apply}}</el-button>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <div class="col-md-12">
              <el-table
                :data="mData.dataForm.ap_dung"
                border
                max-height="440"
                style="width: 100%; display: grid;"
              >
                <el-table-column
                  prop="loai_doi_tuong"
                  :label="aLang.pr_object_type"
                  width="auto"
                  min-width="150"
                >
                  <template slot-scope="scope">      
                    {{fn_findNameById(scope.row.loai_doi_tuong)}}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="link_survey"
                  :label="aLang.pr_link_survey"
                  min-width="200"
                ></el-table-column>              

                <el-table-column :label="aLang.c_action" align="center" width="150px">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="fn_openModalDoiTuong('update',scope.$index)"
                      v-b-popover.hover.left="aLang.c_update"
                      v-if="mData.viewMode != 'detail'"
                    >
                      <i class="icon-pencil icons"></i>
                    </el-button>
                    <el-button
                      size="mini"
                      @click="fn_openModalDoiTuong('detail',scope.$index)"
                      v-b-popover.hover.left="aLang.c_detail"
                    >
                      <i class="fa fa-eye"></i>
                    </el-button>
                    <el-button
                      size="mini"
                      @click="fn_handleDoiTuong('delete',scope.$index)"
                      v-b-popover.hover.left="aLang.c_delete"
                      v-if="mData.viewMode != 'detail'"
                    >
                      <i class="icon-trash icons"></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </b-row>       
         
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- modal Đối tượng -->
    <el-dialog
      :close-on-click-modal="false"
      title="Đối tượng"
      :visible.sync="mData.dialog.DoiTuong"
      width="60%"
      top="51px"
      font-size="13px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormDoiTuong"
          :rules="mData.validFormDoiTuong"
          ref="myFormDoiTuong"
          label-width="100%"
          label-position="top"
        >        
          <b-row>
            <b-col md="6">
              <el-form-item label="Loại đối tượng" prop="loai_doi_tuong">
                <el-select
                  v-model="mData.dataFormDoiTuong.loai_doi_tuong"
                  :placeholder="aLang.c_select"
                  :disabled="mData.dataDefault.DoiTuong.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listLoaiDoiTuong"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Link survey" prop="link_survey">
                <el-input
                  type="text"
                  v-model="mData.dataFormDoiTuong.link_survey"
                  clearable
                  :disabled="mData.dataDefault.DoiTuong.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleDoiTuong('create')"
              v-if="mData.dataDefault.DoiTuong.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleDoiTuong('update')"
              v-if="mData.dataDefault.DoiTuong.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>
            <el-button @click="mData.dialog.DoiTuong = false" type="info" plain>{{aLang.c_close}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ChuongTrinhModel from "./ChuongTrinhModel";
import ChuongTrinhApi from "../../../moduleApi/ChuongTrinhApi";
import HuyHieuApi from "../../../moduleApi/HuyHieuApi";
import EditorComponent from "../../../component/EditorComponent";

export default {
   components: {
    EditorComponent
  },
  data() { 
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "ChuongTrinh",
        dataDefault: {
          roles: DataService.rolesInForm,
          listHuyHieu:[],
        
          listLoaiDoiTuong: ChuongTrinhModel.loaiDoiTuong,
          DoiTuong: {
            viewMode: "create",
            indexModal: undefined
          },
        },
        dataForm: MethodService.copyObject(ChuongTrinhModel.dataForm),
        validForm: ChuongTrinhModel.validForm,
        dataFormDoiTuong: MethodService.copyObject(
          ChuongTrinhModel.dataFormOther.ap_dung
        ),
        validFormDoiTuong: ChuongTrinhModel.validFormOther.ap_dung,
        dialog: {
          DoiTuong: false,
        } 
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      if(this.mData.dataForm.ma){
        this.mData.dataForm.ma = this.mData.dataForm.ma.trim();
      }
      if(this.mData.dataForm.ten.vi){
        this.mData.dataForm.ten.vi = this.mData.dataForm.ten.vi.trim();
      }
      if(this.mData.dataForm.ten.en){
        this.mData.dataForm.ten.en = this.mData.dataForm.ten.en.trim();
      }
      if(this.mData.dataFormDoiTuong.link_survey){
        this.mData.dataFormDoiTuong.link_survey = this.mData.dataFormDoiTuong.link_survey.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await ChuongTrinhApi.create(this.mData.dataForm);
            this.fn_resetForm();
            this.fn_go(-1);
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await ChuongTrinhApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_resetFormDoiTuong() {
      this.$refs["myFormDoiTuong"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await ChuongTrinhApi.findById(id);
      
      this.mData.dataForm = res.result;
    },
    async fn_initDataDefault() {
        let resHuyHieu=await HuyHieuApi.list({limit:1000});        
        this.mData.dataDefault.listHuyHieu=resHuyHieu.result;
    },


    fn_openModalDoiTuong(type, id) {
      this.mData.dialog.DoiTuong = true;      
      if (type == "create") {
        this.mData.dataDefault.DoiTuong.indexModal = undefined;
        this.mData.dataDefault.DoiTuong.viewMode = type;
        this.mData.dataFormDoiTuong = MethodService.copyObject(
          ChuongTrinhModel.dataFormOther.ap_dung
        );
      } else {
        this.mData.dataDefault.DoiTuong.indexModal = id;
        this.mData.dataDefault.DoiTuong.viewMode = type;
        this.mData.dataFormDoiTuong = MethodService.copyObject(
          this.mData.dataForm.ap_dung[id]
        );       
      }    
    },  
    fn_handleDoiTuong(type, index) {
      if (type == "create") {
        this.$refs["myFormDoiTuong"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormDoiTuong);            
            if (!this.mData.dataForm.ap_dung){              
              this.mData.dataForm.ap_dung=[];
            }
            this.mData.dataForm.ap_dung.push(item);
            this.fn_resetFormDoiTuong();
            this.mData.dialog.DoiTuong = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "update") {
        this.$refs["myFormDoiTuong"].validate(async valid => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormDoiTuong);           
            this.mData.dataForm.ap_dung.splice(
              this.mData.dataDefault.DoiTuong.indexModal,
              1,
              item
            );
            this.fn_resetFormDoiTuong();
            this.mData.dialog.DoiTuong = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }

      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.mData.dataForm.ap_dung.splice(index, 1);
          })
          .catch(() => {});
      }
    }, 
    fn_findNameById(doi_tuong_id){
      let resName='';
      let resFind=this.mData.dataDefault.listLoaiDoiTuong.find(
        element => {
            return element.code == doi_tuong_id;
          }
      );
      if (resFind) {
        resName=resFind.text;
      }
      return resName;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>